import React from "react";
import { graphql, useStaticQuery } from "gatsby";

const Article = ({ title, image, datePublished, dateModified, author, description }) => {
    // Отримуємо дані про організацію з налаштувань теми
    const { acfTheme } = useStaticQuery(graphql`
        query QueryAcfThemeArticle {
          acfTheme: wp {
            acfThemeGeneralSettings {
              aCFoptionTemplate {
                micromarkup { 
                  name
                  logo {
                    node {
                      localFile {
                        publicURL
                      }
                    }
                  }
                }  
              }
            }
          } 
        }
    `);

    const { micromarkup } = acfTheme.acfThemeGeneralSettings.aCFoptionTemplate;

    // Створюємо JSON-LD структуру для статті
    const jsonLd = {
        "@context": "http://schema.org",
        "@type": "Article",
        "headline": title,
        "image": {
            "@type": "ImageObject",
            "url": image || "https://molfarpublishing.ua/blog-article.jpg"
        },
        "datePublished": datePublished,
        "dateModified": dateModified || datePublished,
        "author": {
            "@type": "Person",
            "name": author || "Мольфар"
        },
        "publisher": {
            "@type": "Organization",
            "name": micromarkup.name || "Molfar",
            "logo": {
                "@type": "ImageObject",
                "url": "https://molfarpublishing.ua" + micromarkup?.logo?.node?.localFile?.publicURL || "https://molfarpublishing.ua/molfar-logo.jpg"
            }
        },
        "description": description
    };

    return (
        <script
            className="Article"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    );
};

export default Article;